import { ApiResponse, postRequest } from "@/data/apiClient";

export interface SendPasswordResetEmailRequest {
  userName: string;
}

export interface SendPasswordResetEmailResponse {
  ok: boolean;
  errorType: string;
  errorMessage: string;
}

export async function sendPasswordResetEmail(
  req: SendPasswordResetEmailRequest
): Promise<ApiResponse<SendPasswordResetEmailResponse>> {
  return postRequest("user/sendResetPasswordEmail", req);
}
